import { NormalizedNumber, Percentage } from '@sparkdotfi/common-universal'
import BigNumber from 'bignumber.js'

interface CalculateMaxBorrowBasedOnCollateralParams {
  totalCollateralUSD: NormalizedNumber
  totalBorrowsUSD: NormalizedNumber
  maxLoanToValue: Percentage
  borrowingAssetPriceUsd: BigNumber
}

export function calculateMaxBorrowBasedOnCollateral({
  totalCollateralUSD,
  totalBorrowsUSD,
  maxLoanToValue,
  borrowingAssetPriceUsd,
}: CalculateMaxBorrowBasedOnCollateralParams): NormalizedNumber {
  return totalCollateralUSD.times(maxLoanToValue).minus(totalBorrowsUSD).div(NormalizedNumber(borrowingAssetPriceUsd))
}
